<template>
  <div class="link-card">
    <div class="item">
      <a :href='WP_URL+"/events/"'>
        <div class="title">
          <img src="/img/UpcomingEvents.svg" alt="icon" />
          <p>Upcoming Events</p>
        </div>
        <span class="button-rg-yellow">View</span>
      </a>
    </div>
    <div class="item">
      <a :href='WP_URL+"/professional-development/"'>
        <div class="title">
          <img src="/img/ProDev.svg" alt="icon" />
          <p>Professional Development</p>
        </div>
        <span class="button-rg-yellow">Explore</span>
      </a>
    </div>
    <div class="item">
      <a :href='WP_URL+"/community/"'>
        <div class="title">
          <img src="/img/Networking.svg" alt="icon" />
          <p>Community and Networking</p>
        </div>
        <span class="button-rg-yellow">Explore</span>
      </a>
    </div>
    <div class="item">
      <a :href='WP_URL+"/news/"'>
        <div class="title">
          <img src="/img/LatestNews.svg" alt="icon" />
          <p>News and Insights</p>
        </div>
        <span class="button-rg-yellow">View</span>
      </a>
    </div>
    <div class="item">
      <a :href='WP_URL+"/discounts/"'>
        <div class="title">
          <img src="/img/Marketplace.svg" alt="icon" />
          <p>OHI Marketplace</p>
        </div>
        <span class="button-rg-yellow">Explore</span>
      </a>
    </div>
    <div class="item">
      <a :href='WP_URL+"/about-ohi/contact-ohi/"'>
        <div class="title">
          <img src="/img/Store.svg" alt="icon" />
          <p>Contact OHI</p>
        </div>
        <span class="button-rg-yellow">Get In Touch</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      WP_URL: process.env.VUE_APP_WP_WEBSITE_URL,
    };
  },
};
</script>
<style lang="scss" scoped>
.link-card {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 50px;
  grid-row-gap: 50px;
  margin-top: 50px;

  .item {
    a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
    a,
    .title {
      p {
        font-size: 22px;
        margin: 24px 0;
        color: #617042;
      }
    }
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 32px;
    grid-column-gap: 20px;
    .item {
    .title {
      p {
        font-size: 18px;
        margin: 20px 0;
      }
    }
  }
  }
}
</style>
